export default __webpack_public_path__ + "static/media/balance.3c35a052.png";